import {inject, Injectable}                                                                                             from '@angular/core';
import {CrudRecordType, CrudRecordTypes, GlobalDataTypesDict, GlobalRecordType, HkitRecordLogTypes, HkitRecordSumTypes} from '@djsharkk/logr-types';
import * as d3                                                                                                          from 'd3';
import {DataAsstService}                                                                                                from '../asst/data-asst.service';
import {DataBodyService}                                                                                                from './data-fire/data-body.service';
import {DataCaffService}                                                                                                from './data-fire/data-caff.service';
import {DataFirebaseBase}                                                                                               from './data-fire/data-firebase.base';
import {DataFoodService}                                                                                                from './data-fire/data-food.service';
import {DataHkitService}                                                                                                from './data-fire/data-hkit.service';
import {DataMedsService}                                                                                                from './data-fire/data-meds.service';
import {DataMindService}                                                                                                from './data-fire/data-mind.service';
import {DataMoodService}                                                                                                from './data-fire/data-mood.service';
import {DataVapeService}                                                                                                from './data-fire/data-vape.service';
import {DataOuraService}                                                                                                from './data-oura/data-oura.service';
import {DataRizeService}                                                                                                from './data-rize/data-rize.service';

@Injectable({
				providedIn: 'root'
			})
export class DataFactoryService {

	private colorTheme: Record<CrudRecordType, string> = {} as Record<
		CrudRecordType,
		string
	>;

	svcDataVape = inject(DataVapeService)
	svcDataMeds = inject(DataMedsService)
	svcDataMood = inject(DataMoodService)
	svcDataMind = inject(DataMindService)
	svcDataBody = inject(DataBodyService)
	svcDataCaff = inject(DataCaffService)
	svcDataFood = inject(DataFoodService)
	svcDataHkit = inject(DataHkitService)
	svcDataOura = inject(DataOuraService)
	svcDataRize = inject(DataRizeService)
	svcDataAsst = inject(DataAsstService)


	public crudDataSvcs: {
		[key in CrudRecordType]: DataFirebaseBase<any, any>
	} = {
		vape: this.svcDataVape,
		meds: this.svcDataMeds,
		mood: this.svcDataMood,
		mind: this.svcDataMind,
		body: this.svcDataBody,
		caff: this.svcDataCaff,
		food: this.svcDataFood
	}


	async initData(): Promise<string> {
		await this.initTheme();

		await this.svcDataVape.initializeData()
		await this.svcDataMeds.initializeData()
		await this.svcDataCaff.initializeData()
		await this.svcDataMood.initializeData()
		await this.svcDataFood.initializeData()
		await this.svcDataMind.initializeData()
		await this.svcDataBody.initializeData()
		await this.svcDataRize.initializeData()
		await this.svcDataOura.initializeData()
		await this.svcDataHkit.initializeData(true)
		return 'Data Loaded';
	}


	async initTheme() {


		// this.scaleBuilder(CrudRecordTypes, d3.interpolateCool);
		this.scaleBuilder([
							  ...CrudRecordTypes,
							  ...HkitRecordLogTypes,
							  ...HkitRecordSumTypes
						  ], d3.interpolateViridis);


	}

	scaleBuilder<T extends GlobalRecordType>(types: T[], interpolator: (t: number) => string) {
		const scale = d3
			.scaleOrdinal<T, string>()
			.domain(types)
			.range(d3.quantize(interpolator, types.length))
		types.forEach((type) => GlobalDataTypesDict[type].colorHex = scale(type));
	}


}
